module.exports = __webpack_public_path__ + "static/media/machine-tests-bg.2ae20347.png";